import Api from '../../shared/Api';

class PaymentJournalApi {
    static getPaymentJournalList(): Promise<any> {
        return new Api().get('/views/payment-journal');
    }

    static getPaymentJournal(id: number): Promise<any> {
        return new Api().get('/views/payment-journal/' + id);
    }

    static createPaymentJournal(legalEntityId: number, site: number): Promise<any> {
        return new Api().post('/views/payment-journal', {
            legalEntityId: legalEntityId,
            site: site
        });
    }
}

export default PaymentJournalApi;
